module.exports = __webpack_public_path__ + "img/09fbf92.jpg";